const { isString, trim, escapeRegex } = require("simpul");
const sanitize = require("sanitized");
const safeR = require("safe-regex");

function cleanAndSafe(string, option = {}) {
  if (isString(string)) {
    const sanitized = sanitize(string);

    const clean = option.useSanitizedString ? sanitized : trim(sanitized);

    const isSafeR = safeR(clean);

    const escaped = escapeRegex(clean);

    return { sanitized, clean, isSafeR, escaped };
  } else return {};
}

module.exports = cleanAndSafe;
